import React from "react";

export function AccountCross() {
    return (
        <div>account-cross</div>
    )
}